
import styled from "styled-components";

export const DesktopPage = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const DesktopTitle = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #293142;
  margin: 0;
`;



export const CellText = styled.span`
  font-size: 14px;
  color: #293142;
`;

export const BidIdLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #293142;
  text-decoration: underline;
  text-decoration-style: dotted;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  background: ${({ $status }) => {
    const map = {
      live: "#fff3f4",
      upcoming: "#fffbeb",
      awarded: "#f0fdf4",
      submitted: "#eff6ff",
      not_awarded: "#f9fafb",
      no_submission: "#f9fafb",
      completed: "#f0fdf4",
      previous: "#f9fafb",
    };
    return map[$status] || "#f3f4f6";
  }};
  color: ${({ $status }) => {
    const map = {
      live: "#e23744",
      upcoming: "#d97706",
      awarded: "#16a34a",
      submitted: "#2563eb",
      not_awarded: "#6b7280",
      no_submission: "#6b7280",
      completed: "#16a34a",
      previous: "#6b7280",
    };
    return map[$status] || "#374151";
  }};
`;

export const LocationCell = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;

  svg {
    flex-shrink: 0;
  }

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const StateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 120px 0;
  gap: 16px;
`;

export const StateTitle = styled.p`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #293142;
  text-align: center;
`;

export const StateMessage = styled.p`
  margin: 0;
  max-width: 320px;
  font-size: 15px;
  color: #767c8f;
  text-align: center;
  line-height: 22px;
`;

export const StateButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: #ef4f5f;
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
`;
